import React, { Component } from 'react'
import styles from './style.scss'
import 'grommet/scss/vanilla/index.scss';
import Messages from '../../views/Messages'
import Auth from '../../views/Auth'
import Home from '../../views/Home'
import Settings from '../../views/Settings'
import Requests from '../../views/Requests'
import Users from '../../views/Users'
import {
  Route,
  Link,
  Switch,
  Redirect
} from 'react-router-dom'

class BaseLayout extends Component {

  render() {

    if(!document.cookie.length || document.cookie.indexOf('stva') === -1)
      return <Auth />

    return (
        <React.Fragment>
            <div className={styles.header}>
                <div className={styles.title}>Tutorat Sofia</div>
                <div className={styles.nav}>
                  <Link to="/home">Home</Link>
                  <Link to="/messages">Messages</Link>
                  <Link to="/requests">Requests</Link>
                  <Link to="/users/client">Clients</Link>
                  <Link to="/users/tutor">Tutors</Link>
                  <Link to="/settings">Settings</Link>
                </div>
            </div>

            <Switch>
              <Route path="/home" component={Home} />
              <Route path="/messages/:uuid" component={Messages} />
              <Route path="/messages" component={Messages} />
              <Route path="/requests/:uuid" component={Requests} />
              <Route path="/requests" component={Requests} />
              <Route path="/users/:role/:uuid" component={Users} />
              <Route path="/users/:role/" component={Users} />
              <Route path="/settings" component={Settings} />
              <Redirect from='/' to='/home'/>
            </Switch>
            
        </React.Fragment>
    );
  }
}

export default BaseLayout;



// WEBPACK FOOTER //
// ./src/layouts/BaseLayout/index.js